import { render, staticRenderFns } from "./HomeLoanListDataTable.vue?vue&type=template&id=283ec11a&scoped=true"
import script from "./HomeLoanListDataTable.vue?vue&type=script&lang=js"
export * from "./HomeLoanListDataTable.vue?vue&type=script&lang=js"
import style0 from "./HomeLoanListDataTable.vue?vue&type=style&index=0&id=283ec11a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283ec11a",
  null
  
)

export default component.exports